export const GET_SALES = "getSales";
export const GET_SALE = "getSale";
export const CHANGE_SALE_STATUS = "changeSaleStatus"